import { createSlice } from "@reduxjs/toolkit";
import { decrypt, formatTime } from "../../utils";
import moment from "moment";
import { isLate } from "../../pages/Home/Medication/MedicationLogTab/MedicationLogTable";

const initialState = {
  loadingCount: true,
  marLoading: false,
  staffLoadingCount: true,
  ordersCount: {
    lasyDayOrders: 0,
    monthOrders: 0,
    todayOrders: 0,
    weekOrders: 0,
  },
  notes: [],
  tasks: [],
  mars: [],
  allData: [],
  dashboardPendingNotes: [],
  dashboardPendingNotesLoading: false,
  dashboardPendingActions: [],
  dashboardPendingActionsLoading: false,
  dashboardPendingActionsCount: 0
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action?.payload
      };
    },
    setOrdersCount(state, action) {
      return {
        ...state,
        loadingOrdersCount: false,
        ordersCount: action.payload
      };
    },
    setOrdersCountLoading(state, action) {
      return {
        ...state,
        loadingOrdersCount: action.payload
      };
    },

    setDashboardCounts(state, action) {
      return {
        ...state,
        loadingCount: false,
        dashboardCounts: action.payload
      };
    },

    setDashboardNotes(state, action) {
      if (!Array.isArray(action.payload)) {
        return state;
      }
      return {
        ...state,
        loading: false,
        notes: action.payload,
      };
    },
    setDashboardTasks(state, action) {
      if (!Array.isArray(action.payload)) {
        return state;
      }
      return {
        ...state,
        loading: false,
        tasks: action.payload,
      };
    },
    setStaffDashboardCounts(state, action) {
      return {
        ...state,
        staffDashboardCounts: action.payload,
      };
    },
    setDashboardPendingNotes(state, action) {
      return {
        ...state,
        loading: false,
        dashboardPendingNotes: action.payload,
      };
    },
    setDashboardPendingNotesLoading(state, action) {
      return {
        ...state,
        dashboardPendingNotesLoading: action.payload,
      };
    },
    setDashboardPendingActions(state, action) {
      return {
        ...state,
        loading: false,
        dashboardPendingActions: action.payload?.data || [],
        dashboardPendingActionsCount: action.payload?.count || 0,
      };
    },
    setDashboardPendingActionsLoading(state, action) {
       return {
        ...state,
        dashboardPendingActionsLoading: action.payload,
      };
    },
    setStaffLoadingCount(state, action) {
      return {
        ...state,
        staffLoadingCount: action.payload,
      };
    },
    setDashboardMAR(state, action) {
      let _mar = [];
      let _allData = [];
      if (action?.payload?.newMar?.length > 0) {
        action?.payload?.newMar?.forEach((v, i) => {
          const _decrypt = decrypt(v?.client?.form3);
          const filtered = _decrypt?.find(
            (x) => Number(x?.id) === Number(v?.medicationId)
          );
          if (filtered) {
            _mar.push({
              ...v,
              form3: filtered ? filtered : null,
            });
          }
        });
      }
      if (action?.payload?.allData?.length > 0) {
        action?.payload?.allData?.forEach((v, i) => {
          const _isLate = isLate(
            v?.date,
            v?.timeSlot,
            v?.createdAt,
            v?.medicationType
          );

          const _decrypt = decrypt(v?.client?.form3);
          const filtered = _decrypt?.find(
            (x) => Number(x?.id) === Number(v?.medicationId)
          );
          // _decrypt?.find((x) => x?.id === v?.medicationId) || _decrypt?.[0];
          if (filtered) {
            _allData.push({
              date: moment(v?.date).format("DD-MM-YYYY") || "-",
              clientName: decrypt(v?.client?.name) || v?.client?.name || "-",
              medicationName: filtered?.medicationName || "-",
              dosage: v?.dosage || "-",
              ingestionMode: filtered?.ingestionMode || "-",
              isNarcotic: filtered?.isNarcotic || "No",
              medicineRemaining: v?.medicineRemaining || "-",
              frequency: v?.form3?.frequency || "-",
              timeSlot: v?.timeSlot || "-",
              staff: v?.staff ? formatTime(v?.createdAt) : "-" || "-",
              staffName: v?.staff?.name || "-",
              medicationType:
                v?.medicationType === "upcoming"
                  ? !moment(v.date).isBefore(moment().format("MM-DD-YYYY"))
                    ? "Upcoming"
                    : "Missed"
                  : v?.medicationType,
              late: _isLate,
            });
          }
        });
      }
      return {
        ...state,
        mars: _mar,
        count: action?.payload?.count,
        loading: false,
        allData: _allData,
      };
    },
    setDashboardMARLoading(state, action) {
      return {
        ...state,
        marLoading: action.payload,
      };
    },
  }
});

export const {
  setOrdersCount,
  setOrdersCountLoading,
  setDashboardCounts,
  setStaffDashboardCounts,
  setDashboardCountLoading,
  setLoading,
  setDashboardNotes,
  setStaffLoadingCount,
  setDashboardPendingNotes,
  setDashboardPendingNotesLoading,
  setDashboardMAR,
  setDashboardTasks,
  setDashboardMARLoading,
  setDashboardPendingActions,
  setDashboardPendingActionsLoading
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
